import { WebhookStepSummary } from "components/CC/RunHistory/StepDetails/utils/types";
import { CodeEditor } from "components/UI/CodeEditor";
import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

export interface StepDetailWebhookProps {
    extractedData: WebhookStepSummary;
}

export const StepDetailWebhook: FC<StepDetailWebhookProps> = ({ extractedData }) => {
    const { t } = usePaldockTranslation("drawers.step-detail.webhook");
    const { id, request } = extractedData;

    const requestDisplay = {
        ...(request.method ? { method: request.method } : {}),
        ...(request.query ? { query: request.query } : {}),
        ...(request.payload != null ? { payload: request.payload } : {}),
    };

    return (
        <DrawerCollapsible title={t("request")}>
            <CodeEditor
                className="!max-h-80 rounded-lg border"
                id={`step-detail-webhook-request-${id}`}
                wrapEnabled
                minLines={10}
                maxLines={20}
            >
                {JSON.stringify(requestDisplay, null, 2)}
            </CodeEditor>
        </DrawerCollapsible>
    );
};
